import request from '@/utils/request'

export async function getDemandBaseData(demandCd) {
  return request({
    url: '/api/getDemandBaseData',
    method: 'post',
    params: { demandCd: demandCd },
  })
}
